import { render } from "./CardComplianceForm.vue?vue&type=template&id=70f44c42"
import script from "./CardComplianceForm.vue?vue&type=script&lang=js"
export * from "./CardComplianceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__